/**
 * Canonical chain keys used by the frontend.
 * @readonly
 * @enum {string}
 */
export const CHAIN_KEYS = {
  ETHEREUM: 'ethereum',
  BSC: 'bsc',
  ADI: 'adi',
  SOLANA: 'solana',
};

/**
 * Canonical wallet state shape used by wallet adapters.
 * @typedef {Object} WalletState
 * @property {boolean} isConnected
 * @property {string} address
 * @property {string} chainKey
 * @property {string} networkLabel
 * @property {boolean} isCorrectNetwork
 * @property {string|null} currentNetworkId
 */

/**
 * Swap capability shape provided by per-chain adapters.
 * @typedef {Object} SwapCapabilities
 * @property {boolean} requiresApproval
 * @property {boolean} supportsSimulation
 * @property {boolean} supportsNetworkSwitch
 */

/**
 * Balance payload returned by adapter reads.
 * @typedef {Object} ChainBalances
 * @property {string} inputBalance
 * @property {string} outputBalance
 * @property {Object} [diagnostics]
 */

/**
 * Generic swap operation result returned by adapters.
 * @typedef {Object} SwapOperationResult
 * @property {boolean} ok
 * @property {string} status
 * @property {'success'|'error'|'info'} statusType
 * @property {string} [txHash]
 */
